import { useTheme } from '@mui/material';

import { colors } from '@constants/colors';
import { ScreenSizes } from '@interfaces';

export const useStyles = () => {
  const { breakpoints } = useTheme();

  return {
    root: {
      display: 'flex',
      alignItems: 'center',
    },
    icon: {
      color: colors.black,
      width: '18px !important',
      height: '18px !important',
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        width: '14px !important',
        height: '14px !important',
      },
    },
    select: {
      color: colors.black,
      width: '100%',
      overflow: 'hidden',
      '& .MuiInputBase-root': {
        opacity: 1,
        width: '100%',
      },
      '& .MuiSelect-select': {
        display: 'flex',
        alignItems: 'center',
        '& p': {
          paddingLeft: '20px',
          color: `${colors.black} !important`,
        },
      },
      '& svg': {
        color: colors.black,
      },
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        display: 'flex',
        alignItems: 'center',
        '& svg': {
          width: '20px !important',
          height: '20px !important',
          position: 'absolute',
          top: '50%',
          transform: 'translateY(-50%)',
        },
        '& input': {
          padding: 0,
          border: 'none',
        },
        '& .MuiSelect-select': {
          '& p': {
            paddingLeft: '15px',
          },
        },
      },
    },
  };
};
